import React from 'react';

export default function Input({ 
  label, 
  value, 
  onChange, 
  type = 'text',
  placeholder = '',
  error = false,
  helperText = '',
  fullWidth = false,
  size = 'medium',
  className = '',
  ...props 
}) {
  const sizeClasses = {
    small: 'px-3 py-1.5 text-sm',
    medium: 'px-4 py-2 text-base',
  };

  const inputClasses = `
    ${sizeClasses[size]}
    ${fullWidth ? 'w-full' : ''}
    border rounded-sm text-gray-800
    ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-primary-500'}
    focus:outline-none focus:ring-2 focus:border-transparent
    transition-all duration-200 bg-white
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label className="block text-xs font-normal text-gray-400 mb-1">
          {label}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={inputClasses}
        {...props}
      />
      {helperText && (
        <p className={`mt-1 text-sm ${error ? 'text-red-600' : 'text-gray-500'}`}>
          {helperText}
        </p>
      )}
    </div>
  );
}
